var React = require('react');

function Bed (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M1.9 8h5c.1 0 .3 0 .3-.2.3-1.5 1.7-2.5 3.2-2.5h3.3c1.5 0 2.8 1 3.2 2.5-.1.2.1.2.2.2h5c.2 0 .3-.1.3-.3V5c0-1.2-1-2.2-2.2-2.2H3.8c-1.2 0-2.2 1-2.2 2.2v2.7c0 .2.2.3.3.3zM22.9 9.7H1.1c-.6 0-1.1.5-1.1 1.1v5.7c0 .5.4 1 .9 1.1.1 0 .2.1.2.3V20c0 .6.5 1.1 1.1 1.1s1.1-.5 1.1-1.1v-2.2c0-.2.1-.3.3-.3h16.9c.2 0 .3.1.3.3V20c0 .6.5 1.1 1.1 1.1S23 20.6 23 20v-2.2c0-.1.1-.2.2-.3.5-.1.9-.6.9-1.1v-5.7c-.1-.5-.6-1-1.2-1z"}));
}

Bed.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Bed;

Bed.default = Bed;
